/**
 * Profile / session capabilities confirmed against arkhrmsapi auth + employee routes.
 *
 * Mounted:
 * - GET  /auth/me
 * - POST /auth/change-password
 * - POST /auth/logout
 * - GET  /employees/:employeeId — optional enrichment for the signed-in employee
 * - GET  /organization (SETTINGS_VIEW) — optional organization name
 *
 * Not mounted:
 * - Self-service profile update
 * - Profile photo upload / remove
 * - Active sessions list / revoke
 * - Logout all devices
 */
export const PROFILE_CAPABILITIES = {
  viewMyProfile: true,
  changePassword: true,
  logout: true,
  /** No dedicated system-activity / audit-log API yet. */
  systemActivity: false,
  editProfile: false,
  uploadPhoto: false,
  removePhoto: false,
  activeSessions: false,
  logoutAllDevices: false,
  logoutSelectedSession: false,
} as const;
